import script from "./ScormUploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScormUploadModal.vue?vue&type=script&setup=true&lang=js"

import "./ScormUploadModal.vue?vue&type=style&index=0&id=64047604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64047604"]])

export default __exports__